import { render, staticRenderFns } from "./ViTeacherAcademicManagementSubject.vue?vue&type=template&id=50fa36d4"
import script from "./ViTeacherAcademicManagementSubject.vue?vue&type=script&lang=js"
export * from "./ViTeacherAcademicManagementSubject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports